import * as Styles from "./styles";

export function Apresentacao() {
  return (
    <Styles.Container>
      <header>
        Perfil socioeconômico, laboral e comportamental dos(as)
        trabalhadores(as) do SUS no combate à covid-19 no Nordeste
      </header>
    </Styles.Container>
  );
}
